import api from './api';

// Product Variant Services
export const variantService = {
  // Get all variants with pagination
  getVariants: async (params = {}) => {
    const response = await api.get('/variants', { params });
    return response.data;
  },

  // Get variants by product ID
  getVariantsByProduct: async (productId) => {
    const response = await api.get(`/variants/product/${productId}`);
    return response.data;
  },

  // Get variant by ID
  getVariantById: async (id) => {
    const response = await api.get(`/variants/${id}`);
    return response.data;
  },

  // Create new variant
  createVariant: async (variantData) => {
    // If variantData is already FormData, use it directly
    if (variantData instanceof FormData) {
      const response = await api.post('/variants', variantData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    }

    // Otherwise, create FormData from object
    const formData = new FormData();
    formData.append('productId', variantData.productId);
    formData.append('attributes', JSON.stringify(variantData.attributes || []));
    formData.append('price', variantData.price);
    formData.append('stock', variantData.stock);
    formData.append('isActive', variantData.isActive);
    
    if (variantData.sku) formData.append('sku', variantData.sku);
    if (variantData.keyIngredients) {
      formData.append('keyIngredients', JSON.stringify(variantData.keyIngredients));
    }
    if (variantData.howToUse) {
      formData.append('howToUse', JSON.stringify(variantData.howToUse));
    }
    if (variantData.existingImages) {
      formData.append('existingImages', JSON.stringify(variantData.existingImages));
    }
    if (variantData.images && variantData.images.length > 0) {
      variantData.images.forEach(image => {
        formData.append('images', image);
      });
    }
    if (variantData.video) {
      formData.append('video', variantData.video);
    }

    const response = await api.post('/variants', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Update variant
  updateVariant: async (id, variantData) => {
    // If variantData is already FormData, use it directly
    if (variantData instanceof FormData) {
      const response = await api.put(`/variants/${id}`, variantData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    }

    // Otherwise, create FormData from object
    const formData = new FormData();
    formData.append('attributes', JSON.stringify(variantData.attributes || []));
    formData.append('price', variantData.price);
    formData.append('stock', variantData.stock);
    formData.append('isActive', variantData.isActive);
    
    if (variantData.sku) formData.append('sku', variantData.sku);
    if (variantData.keyIngredients) {
      formData.append('keyIngredients', JSON.stringify(variantData.keyIngredients));
    }
    if (variantData.howToUse) {
      formData.append('howToUse', JSON.stringify(variantData.howToUse));
    }
    if (variantData.existingImages) {
      formData.append('existingImages', JSON.stringify(variantData.existingImages));
    }
    if (variantData.images && variantData.images.length > 0) {
      variantData.images.forEach(image => {
        formData.append('images', image);
      });
    }
    if (variantData.existingVideo) {
      formData.append('existingVideo', variantData.existingVideo);
    }
    if (variantData.video) {
      formData.append('video', variantData.video);
    }

    const response = await api.put(`/variants/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Update variant stock
  updateVariantStock: async (id, stockData) => {
    const response = await api.patch(`/variants/${id}/stock`, stockData);
    return response.data;
  },

  // Set variant as default
  setAsDefault: async (id) => {
    const response = await api.patch(`/variants/${id}/default`);
    return response.data;
  },

  // Delete variant video
  deleteVariantVideo: async (id) => {
    const response = await api.delete(`/variants/${id}/video`);
    return response.data;
  },

  // Delete variant
  deleteVariant: async (id) => {
    const response = await api.delete(`/variants/${id}`);
    return response.data;
  }
};
